export const USER_ACTIONS = {
  ON_LOGIN: "user/ON_LOGIN",
  ON_LOGOUT: "user/ON_LOGOUT",
  ON_UPDATE: "user/ON_UPDATE",
  UPDATE_ADDRESS: "user/UPDATE_ADDRESS",
};
